;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { ReactNode } from "react";
import Link from "next/link";

import styles from "./Badge.module.scss";
export interface BadgeProps {
  children: ReactNode;
  href: string;
  className?: string;
}

const GenreBadge = (props: BadgeProps) => {
  const { children, href, className } = props;
  
  let classNames = styles.genre;

  if (className) {
    classNames += ` ${className}`;
  }

  return (
    <Link className={classNames} href={href} data-sentry-element="Link" data-sentry-component="GenreBadge" data-sentry-source-file="GenreBadge.tsx">
      {children}
    </Link>
  );
}

export default GenreBadge;
